import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { closeModal, setModal } from "../../redux/rightModalSlice";
import moment from "moment";

export default function BilledJobCard({ job, index }) {
    const dispatch = useDispatch();
    
    // Gestisce il click sull'icona di visualizzazione
    const handleViewClick = () => {
        dispatch(setModal({
            mode: 'view',
            id: job._id
        }));
    };
    
    // Calcola il totale della commessa (somma degli item)
    const getTotalAmount = () => {
        if (!job.items || !Array.isArray(job.items)) return 0;
        return job.items.reduce((acc, item) => acc + (parseFloat(item.totalPrice) || 0), 0);
    };
    
    // Formatta il prezzo
    const formatPrice = (price) => {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(price);
    };
    
    return (
        <div className="bg-white shadow-lg rounded-lg p-4 border border-gray-200 flex flex-col">
            <div className="flex justify-between items-start">
                <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                        <h3 className="text-lg font-semibold text-primary-600">
                            {job.code || "Commessa senza codice"}
                        </h3>
                        <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                            Fatturata
                        </span>
                    </div>
                    
                    {job.creationDate && (
                        <p className="text-sm mb-1 text-gray-600">
                            <span className="font-medium">Data:</span> {moment(job.creationDate).format('DD/MM/YYYY')}
                        </p>
                    )}
                    
                    {job.customerLabel && (
                        <p className="text-sm mb-1 text-gray-600">
                            <span className="font-medium">Cliente:</span> {job.customerLabel}
                        </p>
                    )}
                    
                    {job.statusLabel && (
                        <p className="text-sm mb-1 text-gray-600">
                            <span className="font-medium">Stato:</span> {job.statusLabel}
                        </p>
                    )}
                    
                    <div className="mt-2 pt-2 border-t border-gray-100">
                        <p className="text-base font-semibold text-gray-800">
                            Totale: {formatPrice(getTotalAmount())}
                        </p>
                    </div>
                </div>
                
                <div className="flex space-x-2">
                    <button
                        onClick={handleViewClick}
                        className="p-1 rounded-full text-blue-500 hover:bg-blue-100 transition-colors"
                        title="Visualizza Dettagli"
                    >
                        <DynamicIcon iconClass="fas fa-eye" />
                    </button>
                </div>
            </div>
        </div>
    );
}
